import type { DocumentType, RequestedDocument } from "../../document";

/** A row this task asked for. Never authored in the registry — always derived from a task. */
export interface RequestedDocumentRequirement {
  key: string;
  kind: "requested_document";
  documentType: DocumentType;
  acceptedDocumentTypes: readonly DocumentType[];
  required: boolean;
  /** Free text telling one request of a type from another; the whole point of an `other` row. */
  label?: string;
}

/** Namespaces instance requirement keys so they can never collide with a registry key. */
const REQUESTED_DOCUMENT_REQUIREMENT_PREFIX = "requested_document:";

export const requestedDocumentRequirementKey = (entry: Pick<RequestedDocument, "key">): string =>
  `${REQUESTED_DOCUMENT_REQUIREMENT_PREFIX}${entry.key}`;

export const requestedDocumentRequirement = (
  entry: RequestedDocument,
): RequestedDocumentRequirement => ({
  key: requestedDocumentRequirementKey(entry),
  kind: "requested_document",
  documentType: entry.documentType,
  acceptedDocumentTypes: entry.acceptedDocumentTypes ?? [entry.documentType],
  required: entry.required !== false,
  ...(entry.label !== undefined ? { label: entry.label } : {}),
});
